import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ShopItemPropertiesDTO, ShopItemsDTO, ShopOrderPostDTO } from "src/app/http/api-interface";
import { ApiService } from "src/app/http/api.service";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { randomString } from "src/app/util/helpers";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-shop-item-popup",
  templateUrl: "./shop-item-popup.component.html",
})
export class ShopItemPopupComponent implements OnInit, OnDestroy {
  @Input() shopItem!: ShopItemsDTO;
  @Output() closePopup = new EventEmitter<string>();

  notification = {}; 
  loading: boolean = false;
  defaultValue = randomString(6);

  selectedShopItem: ShopItemPropertiesDTO | undefined;
  itemSize: string = "";
  itemColour: string = "";
  quantity: number = 0;

  colourOptions: string[] = [];
  sizeOptions: string[] = [];

  constructor(public apiService: ApiService) {}
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.apiService.clearNotification();
    this.setItemPropertyOptions();
  }

  sizeChanged(event: any) {
    this.itemSize = event.target.value;
    this.setItemPropertyOptions();
  }

  colourChanged(event: any) {
    this.itemColour = event.target.value;
    this.setItemPropertyOptions();
  }

  setItemPropertyOptions() {
    this.sizeOptions = [];
    this.colourOptions = [];
    this.shopItem.ItemProperties.forEach(this.setOptions);
    this.sizeOptions.sort();
    this.colourOptions.sort();

    this.itemSize = this.sizeOptions.length == 1 ? 
      this.sizeOptions[0] : 
      (this.sizeOptions.includes(this.itemSize) ? this.itemSize : "");
    this.itemColour = this.colourOptions.length == 1 ? 
      this.colourOptions[0] : 
      (this.colourOptions.includes(this.itemColour) ? this.itemColour : "");
    
    this.getSelectedItem();
  }

  setOptions = (item: ShopItemPropertiesDTO) => {
    if (!this.sizeOptions.includes(item.Size)) {
      this.sizeOptions.push(item.Size);
    }
    if (!this.colourOptions.includes(item.Colour) && (!this.itemSize || item.Size == this.itemSize)) {
      this.colourOptions.push(item.Colour);
    }
  }

  getSelectOptionLabel(label: string): string {
    return label ? label : "N/A";
  }

  getSelectedItem() {
    this.selectedShopItem = this.shopItem.ItemProperties
      .find(x => x.Colour == this.itemColour && x.Size == this.itemSize);
  }

  async addToCart() {
    this.loading = true;
    this.getSelectedItem();
    if (!this.selectedShopItem) return;
    let order: ShopOrderPostDTO = {
      ShopItemFeeID: this.selectedShopItem.ShopItemFeeID,
      Quantity: this.quantity
    }
    if (await this.apiService.addToCart(order)) {
      this.closeModal();
    }
    this.loading = false;
  }

  closeModal() {
    this.closePopup.emit()
  }
}